import {useDispatch, useSelector} from 'react-redux';
import {useEffect, useState} from 'react';
import {Auth as awsAuth, Hub} from 'aws-amplify';
import {
  UPDATE_AUTH_USER,
  SET_AUTH_TOKEN,
  WORD_PREVIEW_CLIENT,
  resetState,
} from '../../shared/constants/ActionTypes';
import {auth as firebaseAuth} from '../services/auth/firebase/firebase';
import {
  fetchStart,
  fetchSuccess,
  onGetLoggedInCognitoUser,
  onJwtSignIn,
} from '../../redux/actions';
import {AuthType} from '../../shared/constants/AppEnums';
import {defaultUser, clientPortalURL} from '../../shared/constants/AppConst';
import jwtAxios from '../services/auth/jwt-auth/jwt-api';
const crypto = require('crypto');
var algorithm = 'aes-256-ctr';
var password = 'd6F3Efeq';

export const useAuthToken = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const {user} = useSelector(({auth}) => auth);
  // const mobileNbr = useSelector(
  //   ({auth}) => auth.mobileno,
  // );
  // const {paswd} = useSelector(({auth}) => paswd);
  // const {token} = useSelector(({auth}) => token);
  useEffect(() => {
    //Decrypt password
    const decryptpassword = function ({data}) {
      var decipher = crypto.createDecipher(algorithm, password);
      var dec = decipher.update(data, 'hex', 'utf8');
      dec += decipher.final('utf8');
      return dec;
    };
    // Get URL parameter from query string
    const urlParams = new URLSearchParams(window.location.search);
    const currentUrl = window.location.href;

    if (urlParams.size > 0) {
      if (urlParams.has('param')) {
        const encryptedParam = urlParams.get('param'); // Get the encrypted 'param' from URL

        if (encryptedParam) {
          console.log('Encrypted data from URL:', encryptedParam);

          // Decrypt the URL parameter if it exists
          const decryptedData = decryptpassword({data: encryptedParam});

          if (decryptedData) {
            let data = JSON.parse(decryptedData);
            if (Object.values(data).length > 0) {
              localStorage.clear();

              dispatch(resetState());

              let paramValue = null;
              let doctorParam = null;

              // if (urlParams.size > 0) {
              if (Object.values(data).length > 0) {
                paramValue = data;

                doctorParam = paramValue;
                // sessionStorage.setItem('browserparam', JSON.stringify(doctorParam))
                localStorage.setItem(
                  'browserparam',
                  JSON.stringify(doctorParam),
                );
              }
              dispatch(
                onJwtSignIn({
                  mobileNbr: doctorParam.mobileNo,
                  paswd: decryptpassword({data: doctorParam.paswd}),
                }),
              );
            }
          }

          console.log('Decrypted data from URL:', decryptedData);

          // Optionally process the decrypted data here (e.g., update state or send to backend)
          localStorage.setItem('browserparam', JSON.stringify(decryptedData));
        }
      } else {
        if (urlParams.has('mtparam')) {
          const encryptedParam = urlParams.get('mtparam'); // Get the encrypted 'param' from URL

          localStorage.setItem('mtparam', encryptedParam);
        }
      }
    }
  }, []);

  useEffect(() => {
    const awsAuthUser = () =>
      new Promise((resolve) => {
        awsAuth
          .currentAuthenticatedUser()
          .then((user) => {
            resolve();
            if (user) {
              console.log('mangal 1');
              console.log(user, 'user mangl');
              dispatch({
                type: UPDATE_AUTH_USER,
                payload: {
                  authType: AuthType.AWS_COGNITO,
                  uniqueDocID: user.uniqueDocID,
                  uid: user.username,
                  displayName: user.attributes.name,
                  email: user.attributes.email,
                  role: defaultUser.role,
                  photoURL: user.photoURL,
                  token: user.signInUserSession.accessToken.jwtToken,
                  doctorcategory: user.doctorCategory,
                  logo: user.doctorProfile,
                  roleId: user.doctorCategory,
                  qrCode: user.qrCode,
                  mrdDrCheck: user.mrdDrCheck,
                  mrdDrcat: user.mrdDrcat,
                  dischargeSummary: user.dischargeSummary,
                },
              });
            }
          })
          .catch(function (error) {
            resolve();
          });
        return Promise.resolve();
      });

    const firebaseCheck = () =>
      new Promise((resolve) => {
        firebaseAuth.onAuthStateChanged((authUser) => {
          if (authUser) {
            console.log('mangal 2');
            console.log(authUser, 'authUser mangl');
            dispatch({
              type: UPDATE_AUTH_USER,
              payload: {
                authType: AuthType.FIREBASE,
                uid: authUser.uid,
                displayName: authUser.displayName,
                email: authUser.email,
                role: defaultUser.role,
                photoURL: authUser.photoURL,
                token: authUser.refreshToken,
                doctorcategory: authUser.doctorCategory,
                logo: authUser.doctorProfile,
                roleId: authUser.doctorCategory,
                uniqueDocID: authUser.uniqueDocID,
                qrCode: authUser.qrCode,
                mrdDrCheck: authUser.mrdDrCheck,
                mrdDrcat: authUser.mrdDrcat,
                dischargeSummary: authUser.dischargeSummary,
              },
            });
          }
          resolve();
        });
        return Promise.resolve();
      });

    const validateAuth = async () => {
      dispatch(fetchStart());
      const chkbrowser = localStorage.getItem('browserparam');

      const token = localStorage.getItem('token');
      if (!token) {
        dispatch(fetchSuccess());
        return;
      }
      dispatch(setJWTToken(token));
      // const mobileNbr = localStorage.getItem('mobileNbr');
      // const paswd = localStorage.getItem('paswd');
      // const token='';
      // const body = {"mobileNbr":mobileNbr, "paswd":paswd};
      //   if(mobileNbr){
      //   try {
      //     await jwtAxios
      //       .post('v1/patMgmt/loginjwt', body)
      //       .then((res) => {
      //         if (res.data.hasOwnProperty.call(res.data, 'message')) {
      //         } else {
      //           // localStorage.setItem('token', res.data.body.token);
      //           // localStorage.setItem('mobileNbr', mobileNbr);
      //           // localStorage.setItem('paswd', paswd);
      //           // token = localStorage.getItem('token');
      //           dispatch(setJWTToken(res.data.body.token));
      //           var body ={"mobileNbr":mobileNbr, "paswd":paswd,"jwtToken":res.data.body.token}
      //           try {
      //               jwtAxios
      //               .post('v1/patMgmt/login', body)
      //               .then((res) => {
      //                 dispatch(fetchSuccess());
      //                 var response = res.data.body[0];
      //                 localStorage.setItem('roleId', '1');
      //                 dispatch({
      //                   type: UPDATE_AUTH_USER,
      //                   payload: {
      //                     authType: AuthType.JWT_AUTH,
      //                     displayName: response.patname,
      //                     email: response.email,
      //                     mobileNo: response.mobileNo,
      //                     doctorCode: response.doctorCode,
      //                     roleId:'1',
      //                     role: 'Patient',
      //                     token: token,
      //                   },
      //                 });
      //               })
      //               .catch((error) => {
      //                 // alert(error.response.data.message.split(':')[1].trim());
      //                 dispatch({type: FETCH_ERROR, payload: (error.response.data.message.split(':')[1].trim())});
      //               });
      //             }
      //              catch (err) {
      //               dispatch(fetchSuccess());
      //               return;
      //             }
      //         }
      //       })
      //       .catch((error) => {
      //         dispatch({
      //           type: FETCH_ERROR,
      //           payload: error.response.data.message.split(':')[1].trim(),
      //         });
      //       });
      //       return;
      //   } catch (err) {
      //     return;
      //   }
      // }
      var body1 = {mobileNbr: '989 ', paswd: '44', jwtToken: token};
      try {
        await jwtAxios
          .post('v1/docMgmt/login', body1)
          .then((res) => {
            dispatch(fetchSuccess());
            var response = res.data.body[0];
            var clientList = response?.generateWordClient;
            let locArr = [];
            if (clientList?.length > 0) {
              clientList.map((item) => {
                if (item?.clientID) {
                  let id = Number(item?.clientID);
                  locArr.push(id);
                }
              });
            }
            dispatch({
              type: WORD_PREVIEW_CLIENT,
              payload: locArr,
            });
            localStorage.setItem('roleId', '1');
            let mappedDoctor =
              response.mappedDoctors && response.mappedDoctors != '0'
                ? response.mappedDoctors.split(',')
                : [];
            mappedDoctor.push(response.doctorCode.toString());
            console.log('mangal3');
            console.log(
              response.dischargeCell,
              'consolee.log(response.dischargeCell) mangal 3',
            );
            dispatch({
              type: UPDATE_AUTH_USER,
              payload: {
                authType: AuthType.JWT_AUTH,
                displayName: response.docname,
                email: response.email,
                mobileNo: response.mobileNo,
                doctorCode: response.doctorCode,
                role:
                  response.doctorCategory == 2 ? 'Doctor' : 'Premium Doctor',
                doctorstatus: response.doctorstatus,
                token: token,
                settings: response.settings,
                mappedDoctor: mappedDoctor,
                doctorcategory: response.doctorCategory,
                logo: response.doctorProfile,
                roleId: response.doctorCategory,
                uniqueDocID: response.uniqueDocID,
                qrCode: response.qrCode,
                transDate: response.transDate,
                mrdDrCheck: response.mrdDrCheck == true ? 3 : '',
                mrdDrcat: response.mrdDrCheck == true ? 'MRD Doctor' : '',
                dischargeSummary: response.dischargeCell,
                medEcho: response.medEcho,
              },
            });
          })
          .catch((error) => {
            // alert(error.response.data.message.split(':')[1].trim());
            // dispatch({type: FETCH_ERROR, payload: (error.response.data.message.split(':')[1].trim())});
          });

        return;
      } catch (err) {
        dispatch(fetchSuccess());
        return;
      }
    };

    const setJWTToken = (token) => {
      return async (dispatch) => {
        dispatch({
          type: SET_AUTH_TOKEN,
          payload: token,
        });
      };
    };

    const checkAuth = () => {
      Promise.all([firebaseCheck(), awsAuthUser(), validateAuth()]).then(() => {
        setLoading(false);
      });
      Hub.listen('auth', ({payload: {event, data}}) => {
        switch (event) {
          case 'signIn':
            dispatch(onGetLoggedInCognitoUser());
            break;
          case 'signOut':
            dispatch({type: UPDATE_AUTH_USER, payload: null});
            break;
          default:
            return false;
        }
      });
    };

    checkAuth();
  }, [dispatch]);

  return [loading, user];
};

export const useAuthUser = () => {
  const {user} = useSelector(({auth}) => auth);

  if (user) {
    return {id: 1, ...user};
  }
  return [null];
};
